const REQUEST_QUOTE_PLACEHOLDER_URL = "https://request-quote.internal";
const REQUEST_QUOTE_REV7_PLACEHOLDER_URL = "https://request-quote-rev7.internal";
const REQUEST_QUOTE_REV8_PLACEHOLDER_URL = "https://request-quote-rev8.internal";

export const REQUEST_QUOTE_REV7_MODAL_ID = "request-quote-rev7";
export const REQUEST_QUOTE_REV8_MODAL_ID = "request-quote-rev8";
export const REQUEST_QUOTE_LEGACY_MODAL_ID = "request-quote";

const QUOTE_MODAL_IDS = new Set([
  REQUEST_QUOTE_REV7_MODAL_ID,
  REQUEST_QUOTE_REV8_MODAL_ID,
  REQUEST_QUOTE_LEGACY_MODAL_ID,
]);

function stripTrailingSlash(href: string) {
  return href.replace(/^(.+?)\/*?$/, "$1");
}

/** Normalize request-quote tokens and internal URLs to the split dialog ids. */
export function requestQuoteModalIdFromHref(href: string) {
  if (href.startsWith("@")) {
    const token = href.slice(1);

    if (token === REQUEST_QUOTE_LEGACY_MODAL_ID) {
      return REQUEST_QUOTE_REV8_MODAL_ID;
    }

    return token === REQUEST_QUOTE_REV7_MODAL_ID || token === REQUEST_QUOTE_REV8_MODAL_ID ? token : undefined;
  }

  const normalized = stripTrailingSlash(href);

  if (normalized === REQUEST_QUOTE_REV7_PLACEHOLDER_URL) {
    return REQUEST_QUOTE_REV7_MODAL_ID;
  }

  if (normalized === REQUEST_QUOTE_REV8_PLACEHOLDER_URL || normalized === REQUEST_QUOTE_PLACEHOLDER_URL) {
    return REQUEST_QUOTE_REV8_MODAL_ID;
  }

  return undefined;
}

export function isRequestQuoteModalId(value?: string): boolean {
  return Boolean(value && QUOTE_MODAL_IDS.has(value));
}

export function softwareSelectionAriaLabel(selected: boolean, title?: string | null) {
  return `${selected ? "Remove" : "Add"} ${title || "software product"}`;
}
